import { apiClient } from 'shared/lib/apiClient';

export interface EquipmentProductView {
  id: string;
  nameKey: string;
  imageUrl: string | null;
}

export interface EquipmentCatalog {
  items: EquipmentProductView[];
}

export interface EquipmentOrderItem {
  productId: string;
  name: string;
  quantity: number;
}

export type EquipmentOrderStatus = 'PENDING' | 'FULFILLED' | 'CANCELLED';

export interface EquipmentOrder {
  id: string;
  submissionId: string;
  items: EquipmentOrderItem[];
  note: string | null;
  status: EquipmentOrderStatus;
  createdAt: string;
  updatedAt: string;
}

export interface CreateOrderItem {
  productId: string;
  quantity: number;
}

export const fetchCatalog = async (): Promise<EquipmentCatalog> => {
  const { data } = await apiClient.get<EquipmentCatalog>(
    '/api/courier/me/equipment/catalog',
  );
  return data;
};

export const fetchOrders = async (): Promise<EquipmentOrder[]> => {
  const { data } = await apiClient.get<{ orders: EquipmentOrder[] }>(
    '/api/courier/me/equipment/orders',
  );
  return data.orders;
};

export const createOrder = async (
  items: CreateOrderItem[],
  note?: string,
): Promise<EquipmentOrder> => {
  const { data } = await apiClient.post<EquipmentOrder>(
    '/api/courier/me/equipment/orders',
    { items, note },
  );
  return data;
};
